{
  "version": 1,
  "asset_id": "e7b5f51c-0405-4353-9a87-c904096a657c",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/e7b5f51c-0405-4353-9a87-c904096a657c/cocktails-menu-bg.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/e7b5f51c-0405-4353-9a87-c904096a657c/cocktails-menu-bg.webp",
  "original_filename": "cocktails-menu-bg.webp",
  "size": 217040,
  "content_type": "image/webp",
  "created_at": "2026-07-04T16:12:45Z"
}
